import React, { lazy, Suspense } from 'react';

const LazyAddPurchase = lazy(() => import('./AddPurchase'));

const AddPurchase = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyAddPurchase {...props} />
  </Suspense>
);

export default AddPurchase;
